import _react, { forwardRef } from "react";
import { filterDOMProps } from "@react-aria/utils";
import { ClearSlots, useDOMRef, useSlotProps, useStyleProps, viewStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";

function $a9d007fb53ec13c8a292d4821c75$var$View(props, ref) {
  props = useSlotProps(props);

  let {
    elementType: ElementType = 'div',
    children
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["elementType", "children"]);

  let {
    styleProps
  } = useStyleProps(props, viewStyleProps);
  let domRef = useDOMRef(ref);
  return /*#__PURE__*/_react.createElement(ElementType, _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    ref: domRef
  }), /*#__PURE__*/_react.createElement(ClearSlots, null, children));
}
/**
 * View is a general purpose container with no specific semantics that can be used for custom styling purposes.
 * It supports Spectrum style props to ensure consistency with other Spectrum components.
 */


export const View = /*#__PURE__*/forwardRef($a9d007fb53ec13c8a292d4821c75$var$View);

function $a359aafecbc772ff97d7c424d8abe$var$Content(props, ref) {
  props = useSlotProps(props, 'content');

  let {
    children
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let domRef = useDOMRef(ref);
  return /*#__PURE__*/_react.createElement("section", _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    ref: domRef
  }), /*#__PURE__*/_react.createElement(ClearSlots, null, children));
}
/**
 * Content represents the primary content within a Spectrum container.
 */


export const Content = /*#__PURE__*/forwardRef($a359aafecbc772ff97d7c424d8abe$var$Content);

function $e81ef0fe4e9ce0b97df516761bb30903$var$Footer(props, ref) {
  props = useSlotProps(props, 'footer');

  let {
    children
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let domRef = useDOMRef(ref);
  return /*#__PURE__*/_react.createElement("footer", _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    ref: domRef
  }), /*#__PURE__*/_react.createElement(ClearSlots, null, children));
}
/**
 * Footer represents a footer within a Spectrum container.
 */


export const Footer = /*#__PURE__*/forwardRef($e81ef0fe4e9ce0b97df516761bb30903$var$Footer);

function $eb7af4a99bd7beb05d29c99e5cb82302$var$Header(props, ref) {
  props = useSlotProps(props, 'header');

  let {
    children
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let domRef = useDOMRef(ref);
  return /*#__PURE__*/_react.createElement("header", _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    ref: domRef
  }), /*#__PURE__*/_react.createElement(ClearSlots, null, children));
}

export const Header = /*#__PURE__*/forwardRef($eb7af4a99bd7beb05d29c99e5cb82302$var$Header);
//# sourceMappingURL=module.js.map
